import { render } from "./ModalForm.vue?vue&type=template&id=45dd1ca7&scoped=true"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import "./ModalForm.vue?vue&type=style&index=0&id=45dd1ca7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dd1ca7"]])

export default __exports__